import { useEffect, useRef } from "react";

const COLORS = [
    "#ffd700", "#ffcf00", "#ffc700", "#ffbf00", "#ffb700", "#ffaf00",
    "#ffa700", "#ff9f00", "#ff9700", "#ff8f00", "#ff8700", "#ff7f00",
    "#e67700", "#cc6f00", "#b36700", "#995f00", "#805700", "#664f00",
    "#4d4700", "#333f00", "#1a3700", "#002f00",
];

const TRAIL_LENGTH = 20;

/**
 * Estela de puntos que sigue al cursor.
 *
 * Solo se activa en dispositivos con puntero fino (mouse/trackpad) y respeta
 * `prefers-reduced-motion`. El bucle de animación y el listener se liberan al
 * desmontar para no dejar frames corriendo en las vistas de streaming.
 */
export default function AnimationMouse() {
    const containerRef = useRef(null);

    useEffect(() => {
        const finePointer = window.matchMedia('(pointer: fine)').matches;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!finePointer || reducedMotion || !containerRef.current) return undefined;

        const coords = { x: 0, y: 0 };
        const circles = Array.from(containerRef.current.querySelectorAll(".circle"));

        circles.forEach((circle, index) => {
            circle.x = 0;
            circle.y = 0;
            circle.style.backgroundColor = COLORS[index % COLORS.length];
            circle.style.display = 'block';
        });

        const handleMouseMove = (event) => {
            coords.x = event.clientX;
            coords.y = event.clientY;
        };

        window.addEventListener("mousemove", handleMouseMove, { passive: true });

        let frameId;
        const animateCircles = () => {
            let x = coords.x;
            let y = coords.y;

            circles.forEach((circle, index) => {
                circle.style.left = x - 12 + "px";
                circle.style.top = y - 12 + "px";
                circle.style.scale = (circles.length - index) / circles.length;

                circle.x = x;
                circle.y = y;

                const nextCircle = circles[index + 1] || circles[0];
                x += (nextCircle.x - x) * 0.3;
                y += (nextCircle.y - y) * 0.3;
            });

            frameId = requestAnimationFrame(animateCircles);
        };

        frameId = requestAnimationFrame(animateCircles);

        return () => {
            cancelAnimationFrame(frameId);
            window.removeEventListener("mousemove", handleMouseMove);
        };
    }, []);

    return (
        <div ref={containerRef} aria-hidden="true">
            {Array.from({ length: TRAIL_LENGTH }).map((_, index) => (
                <div className="circle" key={index} style={{ display: 'none' }}></div>
            ))}
        </div>
    );
}
